// Central asset registry — swap URLs here to update photography site-wide
export const IMG = {
  ramya: "/ramya-headshot.jpg",
  munique: "/munique-crop.jpg",
  // AI-composed editorial two-shot of both co-founders (Gemini Nano Banana, ref: their real headshots)
  cofounders: "/team-back-to-back-v1.jpg",

  // Slick technological accents (data, code, abstract 3D)
  // Services — analytics / dashboard on laptop
  dashboard: "/services-dashboard.jpg",
  // Agents — code / matrix backdrop (subtle)
  matrix: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=1600&q=70",
  // Process — code close-up on monitor
  code: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1400&q=70",
  // Results — live analytics / charts
  analytics: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=70",
  // CTA — abstract 3D geometric forms (warm-toned, atmospheric)
  abstract3d: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&w=1800&q=70",
};
